import { useChatOverlay, buildChatRoute, CHAT_ROUTE_KEY } from '@fs/zion-chat'
import { chatConfig } from '../config'
import { useConferenceContext } from '../providers/ConferenceProvider'

export default function useVendorChatOverlay({ exhibitorId, vendorName = '', imageUrl = '' }) {
  const { getConferenceYear } = useConferenceContext()
  const supportChatInformation = {
    name: vendorName,
    imageUrl,
    externalId: exhibitorId,
    eventLabel: `${chatConfig.EVENT_LABEL_PREFIX}${getConferenceYear()}`,
  }

  const chatOverlay = useChatOverlay(buildChatRoute(CHAT_ROUTE_KEY.CREATE_VENDOR_CHAT), supportChatInformation)
  if (chatOverlay) {
    return chatOverlay
  }
  return null
}
